const SHANGHAI_TIME_ZONE = "Asia/Shanghai";
const SHANGHAI_OFFSET_MS = 8 * 60 * 60 * 1000;

const dayFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: SHANGHAI_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function dashboardDayKey(value = new Date()) {
  return dayFormatter.format(value);
}

export function millisecondsUntilNextShanghaiDay(value = new Date()) {
  const [year, month, day] = dashboardDayKey(value).split("-").map(Number);
  const nextMidnight = Date.UTC(year!, month! - 1, day! + 1) - SHANGHAI_OFFSET_MS;
  return Math.max(1_000, nextMidnight - value.getTime());
}
